export const SET_PRODUCTS = "SET_PRODUCTS";
export const SELECTED_PRODUCT = "SELECTED_PRODUCT";
export const REOMOVE_SELECTED_PRODUCT = "REOMOVE_SELECTED_PRODUCT";
